import { useTranslation } from 'react-i18next'

import translationKeys from '@translationKeys'

import { Divider, Typography } from '@mui/material'

import { EventsTooltipProps } from './types'

const EventsTooltip = ({ attendingEventNames, notAttendingEventNames }: EventsTooltipProps) => {
  const { t } = useTranslation()
  return (
    <>
      {attendingEventNames?.length ? (
        <div>
          <Typography variant="subtitle2">{t(translationKeys.CUSTOM_LIST_TABLE_TOOLTIP_BOTH_ATTENDING)}</Typography>
          {attendingEventNames.map(name => (
            <Typography variant="body2" key={name}>
              {name}
            </Typography>
          ))}
        </div>
      ) : null}
      {notAttendingEventNames?.length && attendingEventNames?.length ? (
        <Divider style={{ margin: '8px 0', background: '#fff' }} />
      ) : null}
      {notAttendingEventNames?.length ? (
        <div>
          <Typography variant="subtitle2">{t(translationKeys.CUSTOM_LIST_TABLE_TOOLTIP_NOT_ATTENDING)}</Typography>
          {notAttendingEventNames.map(name => (
            <Typography variant="body2" key={name}>
              {name}
            </Typography>
          ))}
        </div>
      ) : null}
    </>
  )
}

export default EventsTooltip
